import { Component, OnInit } from '@angular/core';
import{AuthService} from '../auth/auth.service';
import { Router } from '@angular/router';
import { WebServiceService } from 'app/web-service.service';
import { SidebarService } from '../sidebar/sidebar.service';
import { Subscription } from 'rxjs'; 
import { LoaderService } from 'app/loader.service';
@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit{
    
    authService:any;
    emp:string;
    totalCredit: any;
    utilise: any;
    balance: any;
    menuItems:any;
    usermail: any;
    lastname: any;
    subscription: Subscription;
    constructor(authService:AuthService, private router: Router,public service:WebServiceService,private sidebarService: SidebarService,private loaderService: LoaderService)  {
    this.authService=authService;
    this.emp=JSON.parse(sessionStorage.getItem("currentUser")).firstname;
    this.usermail=JSON.parse(sessionStorage.getItem("currentUser")).Email;
    this.lastname=JSON.parse(sessionStorage.getItem("currentUser")).lastName;
    this.subscription = this.loaderService.refreshNavObs().subscribe(res => {
        this.ngOnInit();
      });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    logout(){
        console.log("method called");
        this.authService.logout();
        // this.router.navigate(['login']);
        window.open(location.origin,'_self')
    }
    changepwd(){
        this.router.navigate(['change-pwd']);
    }
    ngOnInit() {
        console.log('NAVBAR@1');
        this.creditDetails();
        // $.getScript('./assets/app/js/core/app-menu.js');
        // $.getScript('./assets/app/js/core/app.js');
        
        // this.menuItems = ROUTES.filter(menuItem => menuItem);
        this.sidebarService.geMenus().subscribe((data:any) =>{
        this.menuItems = data.data
        sessionStorage.setItem('menu',JSON.stringify(data.data))
        for(let i=0;i<this.menuItems.length;i++){
        
        this.menuItems[i].class=this.menuItems[i].icon.split('.')[0];
        this.menuItems[i].icon='assets/'+this.menuItems[i].icon
        
        
        }
        
        
        });
     
        }
        


    creditDetails()
    {
      this.service.httpGet('get/credit/'+JSON.parse(sessionStorage.getItem("currentUser")).agencyId).subscribe((data:any)=>{
            this.balance=data.data.balance
            this.utilise=data.data.utilized
            this.totalCredit=data.data.totalCredit
      })
    }
    // menuclose(){
    //     console.log("menu");
    // }
    respMenuclick(){
        // $('#respmenu').addClass('show');  
    }
    clickmenu(){
        console.log("toggle");
    }
    toggleNavbar(tagId){
       
        // $('.menu-toggle').addClass('menu-hide');
        // $('.menu-hide').addClass('menu-open');
        $('#'+tagId).removeClass('show');
        // $('#respmenu').removeClass('show');  
        // console.log(el)
        console.log("toggle");
        // this.getScreenWidth = document.documentElement.clientWidth;
        // if(this.getScreenWidth < 992)
        // $("body").toggleClass("left-sidebar-hidden")
    }
    togglesidebar(){
        $("body").toggleClass("left-sidebar-hidden");
    }
    toggletempmenu(){
        console.log("toggletempmenu");
        $("body").toggleClass("left-sidebar-hidden")
        $("#sidebarclass").addClass("showclass");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts